import $ from "jquery";
import Menu from "./Menu";
import _f from "./_f";

export default class Header {
    constructor() {
        this.$ELEMENTS = {
            CONTAINER: $('body'),
            HEADER:    $('.site-header'),
            BACK2TOP:  $('.back-to-top'),
            PAGE_FADE: $('.page-fade')
        };

        this.CLASSES = {
            OPEN:   'menu-open',
            HEADER: {
                SCROLLED: 'site-header--scrolled',
                UP:       'site-header--up',
                DOWN:     'site-header--down'
            }
        };

        this.Modules = {
            Menu: new Menu(this.$ELEMENTS.HEADER)
            // MobileMenu: new MobileMenu(),
            // OCCart:     new OCCart()
        };

        this.registerHooks();
    }

    closeAllModules( triggerModule = false ) {
        Object.keys(this.Modules).forEach(( moduleName, i ) => {
            if ( moduleName == triggerModule ) {
                return;
            }

            this.Modules[moduleName].close();
        });
    }

    registerHooks() {
        let $body      = $('body');
        let $container = $(window);
        $container.scroll(() => { this.updateHeaderState(); });
    }

    updateHeaderState() {
        let $window           = $(window);
        let $container        = $window;
        let window__scrollTop = $container.scrollTop(),
            $header           = this.$ELEMENTS.HEADER;
        let scroll_direction  = f.getScrollDirection(window__scrollTop);

        this.$ELEMENTS.CONTAINER.trigger('wfp:scrollPos:tick', { scrollTop: window__scrollTop, dir: scroll_direction });

        if ( window__scrollTop > 150 )
            $header.addClass(this.CLASSES.HEADER.SCROLLED);
        else {
            $header.removeClass(this.CLASSES.HEADER.SCROLLED);
            $header.removeClass(this.CLASSES.HEADER.UP);
            $header.removeClass(this.CLASSES.HEADER.DOWN);
        }

        if ( scroll_direction === 'UP' ) {
            $header.addClass(this.CLASSES.HEADER.UP);
            $header.removeClass(this.CLASSES.HEADER.DOWN);
        }
        else if ( scroll_direction === 'DOWN' ) {
            $header.addClass(this.CLASSES.HEADER.DOWN);
            $header.removeClass(this.CLASSES.HEADER.UP);
        }

        let $backToTop = this.$ELEMENTS.BACK2TOP;
        if ( window__scrollTop > $window.innerHeight() )
            $backToTop.addClass('active');
        else
            $backToTop.removeClass('active');
    }
}
